import { ApiBase } from 'api/api'
import {
  makeDeleteRequest,
  makePostRequest,
  makePutRequest,
} from 'api/fetchCalls'
import type { UpdateCreateWorkflow, Workflow } from 'types/automations'

export async function createWorkflow(
  data: UpdateCreateWorkflow
): Promise<Workflow> {
  return makePostRequest(`${ApiBase}/calendar/workflows`, {
    body: JSON.stringify(data),
  })
}

export async function updateWorkflow(
  id: number,
  data: UpdateCreateWorkflow
): Promise<Workflow> {
  return makePutRequest(`${ApiBase}/calendar/workflows/${id}`, {
    body: JSON.stringify(data),
  })
}

export async function deleteWorkflow(id: number): Promise<void> {
  return makeDeleteRequest(`${ApiBase}/calendar/workflows/${id}`)
}
